import { Switch, Route } from "react-router-dom";

import Navbar from "../../components/Navbar";
import Dashboard from "./dashboard/Dashboard";
import Project from "./project/Project";
import App from "./app/App";

import "./Console.styles.scss";
import MyProfile from "./myProfile/MyProfile";
import OrganizationDashboard from "./organization/OrganizationDashboard";
import Team from "./team/Team";

const Console = ({ match }) => {
  return (
    <div className="console">
      <Navbar />
      <div className="console_body">
        <div className="console_main">
          <Switch>
            {/* <ProtectedRoute exact path={`${match.url}/`}>
              <Dashboard />
            </ProtectedRoute>
            <ProtectedRoute exact path={`${match.url}/:projectid`}>
              <Dashboard />
            </ProtectedRoute>
            <ProtectedRoute exact path={`${match.url}/:projectid/:appid`}>
              <App />
            </ProtectedRoute> */}
            <Route exact path={`${match?.url}/`} component={Dashboard} />
            {/**
             * Keep the /profile path above /:projectid path
             */}
            <Route exact path={`${match?.url}/profile`} component={MyProfile} />
            <Route exact path={`${match?.url}/team`} component={Team} />
            <Route
              exact
              path={`${match?.url}/organization-dashboard`}
              component={OrganizationDashboard}
            />
            <Route exact path={`${match?.url}/:projectid`} component={Project} />
            <Route path={`${match?.url}/:projectid/:appid`} component={App} />
          </Switch>
        </div>
      </div>
    </div>
  );
};

export default Console;
